import * as React from 'react';
import { Button, IButtonProps, Icons } from 'components';
import { WithTranslation, withTranslation } from 'react-i18next';

export interface IContainerExportButtonProps extends Omit<IButtonProps, 'onClick' | 'text' | 'icon'>, WithTranslation {
    layerCode: string;
    objectIds: number[];
    onClick: (layerCode: string, objectIds: number[]) => any;
    iconInsteadText?: boolean;
}
export interface IContainerExportButtonState {}

class ContainerExportButtonComponent extends React.Component<IContainerExportButtonProps, IContainerExportButtonState> {
    constructor(props: IContainerExportButtonProps) {
        super(props);

        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onButtonClick() {
        this.props.onClick(this.props.layerCode, this.props.objectIds);
    }

    render() {
        let {
            layerCode,
            objectIds,
            onClick,
            iconInsteadText = false,
            ref,
            t,
            i18n,
            tReady,
            ...restButtonProps
        } = this.props;

        let text_and_icon_props: Pick<IButtonProps, 'text' | 'icon'> = {
            icon: iconInsteadText ? <Icons.IconDownload /> : null,
            text: !iconInsteadText ? t('Выгрузить') : null
        };

        return (
            <Button
                onClick={this.onButtonClick}
                /**
                 * Почему-то этот ref не работает. Если понадобится прокидывать ref,
                 * то можно попробовать переписать этот компонент на функциональный
                 * с использованием React.forwardRef
                 */
                // ref={ref}
                {...text_and_icon_props}
                {...restButtonProps}
            />
        );
    }
}

export const ContainerExportButton = withTranslation()(ContainerExportButtonComponent);
